/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMasterDbPingResponseDto } from '../../models/backend-master-db-ping-response-dto';

export interface MasterDbPingDebugMasterDbGet$Params {}

export function masterDbPingDebugMasterDbGet(
  http: HttpClient,
  rootUrl: string,
  params?: MasterDbPingDebugMasterDbGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMasterDbPingResponseDto>> {
  const rb = new RequestBuilder(rootUrl, masterDbPingDebugMasterDbGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMasterDbPingResponseDto>;
    }),
  );
}

masterDbPingDebugMasterDbGet.PATH = '/debug/master-db';
